/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".rp-pdt-info[_ngcontent-%COMP%]{padding:10px 10px 10px 0}.rp-pdt-info[_ngcontent-%COMP%]   ion-avatar[_ngcontent-%COMP%]{width:100px;height:100px;border:1px solid #e2e2e2}.rp-pdt-info[_ngcontent-%COMP%]   ion-avatar[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{-o-object-fit:contain;object-fit:contain}.rp-pdt-info[_ngcontent-%COMP%]   ion-label[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{font-size:17px;text-transform:capitalize}"];
export { styles as styles };
